import { useDesignSystem } from 'contexts/design-system'
import CurrencyFieldEui from './currencyField.eui'
import CurrencyFieldMui from './currencyField.mui'
import { CurrencyFieldProps } from './types'

export type { CurrencyFieldProps } from './types'

/**
 * Shared currency field. Renders the EUI or MUI presentation based on the
 * host form's design system (`DesignSystemProvider`, default `'eui'`); the
 * public props and formatting/validation behavior are identical across both
 * branches. Always rendered inside the consumer's own form row (EUI or
 * `FormRow`), so it owns no label/error presentation itself.
 */
export default function CurrencyField( props: CurrencyFieldProps ) {
	return useDesignSystem() === 'mui'
		? <CurrencyFieldMui {...props} />
		: <CurrencyFieldEui {...props} />
}
